import React from 'react';
import './introduction.css';

import Me from '../../assets/me.png'

const Introduction = () => {
	return (
        <div className="introduction-container m-auto" style={{ marginTop: 16, marginBottom: 16 }}>
            <div className="hello">
                <img src={Me} />
                <h2>Welcome to <span className="add-bb">The Valley Musical</span> workshop! 👋</h2>
            </div>
            <p className="txt">Hey! My name is <b>Mauricio Costa</b>, and I am a computer scientist, software engineer, and musician.
            In the past couple of months, we have seen the collapse of the <b>Silicon Valley Bank</b> and its unprecedented repercussions unfold.</p>
            
            <p className="txt">I have been playing music for the past 15 years and, as a huge fan of musicals, over the past 3 months, I wrote a <b>one-act musical about the Silicon Valley Bank's demise, called <i>The Valley</i></b> (here, we will refer to SVB as "The Valley Bank")</p>
            <p className="txt red">This is a workshop, so the recordings are not intended to be perfect in any way. In fact, most of these vocals were recorded in the middle of the night.</p>
            <p className="txt">This is a "gospel" and hip hop-style comedy musical where Venture Capitalists (VCs) play the role of preachers, startups of naive church goers, and Greg, the CEO of the Valley Bank, well, we'll see 😏.</p>

            <p>⏰ The Valley's Duration: ~18minutes.</p>
            <p>🍿 Get your popcorn and stand up to dance if you can!</p>
            <p>👉 We are currently seeking anyone interested in recording this musical after this workshop and putting a <b>stage production</b>, so feel free to hit me up on any of the socials below.</p>

            {/* <p>
                "what you are about to listen (prologue - thanks for tuning in, here's 10 seconds of our show to get you excited!)"
                pic?
                social at the bottom, (insta, linkedin, spotify, github, email)
                credits at the end
                album cover concept
                buy me a coffee
            </p> */}
        </div>
    )
}

export default Introduction;
